import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import awsconfig from "./aws-exports";
import Amplify, * as AmplifyModules from "aws-amplify";
//import { Auth } from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import { Functions } from "./functions/Functions";
import "bootstrap";
import "bootstrap-select";
import VueGoogleCharts from "vue-google-charts";
import Parse from "parse"

Parse.serverURL = "https://parseapi.back4app.com/parse";
Parse.initialize("9b3zhhgImbyyKw1o79PNtNS11OKUX9bbWQedxb1T", "3VQ70otXfmcpvgo6jFAeD23gEtmL18j76gmWPrUp");
//Parse.serverURL = "http://localhost:1337/parse"
//Parse.initialize("9b3zhhgImbyyKw1o79PNtNS11OKUX9bbWQedxb1T", undefined, "vxMYjQgQgnTKviMl8K4yEAe9sZMBonPgb9rj0ghO")


Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(Vuex);
Vue.use(VueGoogleCharts);
Vue.use(Functions);

Vue.config.productionTip = false;
const { createApolloFetch } = require("apollo-fetch");
const apolloFetch = createApolloFetch({
  uri: process.env.VUE_APP_GRAPHQL_URI
});
apolloFetch.use(async ({ request, options }, next) => {
  if (!options.headers && request != null) {
    options.headers = {};
  }
  /*await Auth.currentSession().then(data => {
    options.headers["Authorization"] = data.idToken.jwtToken;
  });*/
  next();
});

Amplify.configure(awsconfig);

const awsCreds = {
  AccountId: process.env.VUE_APP_AWS_ACCOUNT_ID,
  RoleArn: process.env.VUE_APP_AWS_ROLE_ARN,
  IdentityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID
};
const userPoolId = process.env.VUE_APP_USER_POOL_ID;

const store = new Vuex.Store({
  state: {
    user: null,
    loading: false,
    fetcher: apolloFetch,
    awsCreds: awsCreds,
    userPoolId: userPoolId
  },
  getters: {
    awsCreds: state => {
      return state.awsCreds;
    },
    userPoolId: state => {
      return state.userPoolId;
    },
    fetcher: state => {
      return state.fetcher;
    },
    user: state => {
      return state.user;
    },
    loading: state => {
      return state.loading;
    }
  },
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateLoading(state, loading) {
      state.loading = loading;
    },
    resetUser(state) {
      state.user = null;
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
